import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import Card from '@material-ui/core/Card';
import CardContent from '@material-ui/core/CardContent';
import Typography from '@material-ui/core/Typography';

const useStyles = makeStyles({
  root: {
    width: '100%'
  },
  bullet: {
    display: 'inline-block',
    margin: '0 2px',
    transform: 'scale(0.8)',
  },
  title: {
    fontSize: 14,
  },

});

export default function DashboardCard({featureName, value, valueCompare}) {
  const classes = useStyles();

  return (
    <Card className={classes.root} variant="outlined">
      <CardContent>
        <Typography className={classes.title} color="textSecondary" gutterBottom>
          {featureName}
        </Typography>
        <Typography variant="h5" component="h2">
          {value}
        </Typography>
        <Typography variant="body2" component="p">
          {valueCompare}
        </Typography>
      </CardContent>
    </Card>
  );
}
